function activePackage(state) {
  const pkg = state?.package;
  if (!pkg || pkg.status === 'submitted' || pkg.submittedAt) return null;
  return pkg;
}

function screenIdForCount(item) {
  return item?.screenId || item?.id || item?.metadata?.screenId || null;
}

export function countFeedbackScreens(state) {
  const pkg = activePackage(state);
  if (!pkg) return 0;

  const screens = pkg.screens || [];
  const stage = state.stage;
  if (!stage) return screens.length;

  const stageId = screenIdForCount(stage);
  const stageIsRegistered = screens.some((screen) => screenIdForCount(screen) === stageId);
  return screens.length + (stageIsRegistered ? 0 : 1);
}

export function countFeedbackMarks(state) {
  const pkg = activePackage(state);
  if (!pkg) return 0;

  const screens = pkg.screens || [];
  const stage = state.stage;
  const stageId = screenIdForCount(stage);
  const stageCount = stage?.metadata?.annotations?.length || 0;
  const savedScreenCount = screens.reduce((total, screen) => {
    if (stageId && screenIdForCount(screen) === stageId) return total;
    return total + (screen.metadata?.annotations?.length || 0);
  }, 0);

  return savedScreenCount + stageCount;
}
